.row {
  display: grid;
  grid-template-columns: 140px 1fr 200px;
  gap: 24px;
  padding: 22px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  align-items: flex-start;
}

.thumbLink { flex: 0 0 auto; }

.thumb, .thumbPlaceholder {
  width: 140px;
  height: 140px;
  object-fit: cover;
  background: var(--color-bone);
  border-radius: 6px;
}

.body { min-width: 0; display: flex; flex-direction: column; gap: 6px; }

.name {
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--color-ink);
  text-decoration: none;
  line-height: 1.2;
}

.unit {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--color-ink);
}

.attrs {
  margin: 4px 0 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.attr {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: var(--color-ink);
}

.attr dt { color: var(--color-ink-soft); font-weight: 600; margin: 0; }
.attr dd { margin: 0; display: inline-flex; align-items: center; gap: 6px; }

.mono { font-family: ui-monospace, "SF Mono", Menlo, monospace; font-size: 0.8rem; }

.swatch {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  display: inline-block;
}

.qtyRow {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
}

.stockWarn {
  margin-top: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: #b53b3b;
  letter-spacing: 0.02em;
}

.stockNote {
  margin-top: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--color-ember-dark);
  letter-spacing: 0.02em;
}

.qtyLabel {
  font-size: 0.85rem;
  color: var(--color-ink-soft);
  font-weight: 600;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: stretch;
}

.btnPrimary {
  background: var(--color-ember);
  color: #111;
  text-align: center;
  padding: 10px 12px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  border-radius: 4px;
}

.btnPrimary:hover { background: var(--color-ember-dark); color: #fff; }

.btnDark {
  background: #4a4441;
  color: #fff;
  text-align: center;
  padding: 10px 12px;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  border: 0;
  cursor: pointer;
  border-radius: 4px;
}

.btnDark:hover { background: #2c2825; }

.amountBlock {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
}

.amountLabel { color: var(--color-ink); font-weight: 700; }
.amount { font-weight: 700; }

@media (max-width: 768px) {
  .row {
    grid-template-columns: 96px 1fr;
    grid-template-areas:
      "thumb body"
      "actions actions";
    gap: 14px;
    padding: 16px 0;
  }
  .thumbLink { grid-area: thumb; }
  .thumb, .thumbPlaceholder { width: 96px; height: 96px; }
  .body { grid-area: body; }
  .actions {
    grid-area: actions;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: stretch;
  }
  .actions > .btnPrimary, .actions > .btnDark { flex: 1 1 30%; }
  .amountBlock { width: 100%; flex-basis: 100%; }
}
